module.exports = __webpack_public_path__ + "img/header-weddingRingsCheap.97f581d.webp";